import { render, staticRenderFns } from "./SiftMaterial.vue?vue&type=template&id=7a03983b&scoped=true&"
import script from "./SiftMaterial.vue?vue&type=script&lang=js&"
export * from "./SiftMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a03983b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a03983b')) {
      api.createRecord('7a03983b', component.options)
    } else {
      api.reload('7a03983b', component.options)
    }
    module.hot.accept("./SiftMaterial.vue?vue&type=template&id=7a03983b&scoped=true&", function () {
      api.rerender('7a03983b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/components/SiftMaterial.vue"
export default component.exports